/**
 * Hardcoded staff allowlist for the super-admin dashboard.
 *
 * Must match `STAFF_USER_IDS` in `workers/leads/src/routes/admin.ts`
 * — the backend gate is the source of truth, but mirroring it here lets
 * us hide UI early so non-staff don't see broken admin links.
 */
export const STAFF_USER_IDS: ReadonlySet<string> = new Set([
  'user_3BME50OEjstIWRWux8UonVnxb8M', // TJ. TODO(Eli): TJ needs a non-KNWN4 login
  'user_3IBkHGaR6ol01VPPEIecEvQCAfb', // eli@jahvis.ai (Eli)
  'user_3C4CzlgLjarwyXJkhGHHXMGA2SE', // taha.a.hashmi@gmail.com (Taha)
])

export function isStaffUser(userId: string | null | undefined): boolean {
  return Boolean(userId && STAFF_USER_IDS.has(userId))
}

/**
 * QA testers (2026-09-25): can open the admin console READ-ONLY. The leads
 * worker only lets them make GET requests (canUseAdmin in routes/admin.ts)
 * and the gateway ignores their X-Impersonate-User-Id, so the UI hides the
 * write actions and "Open dashboard as this user" for them.
 * Must match QA_USER_IDS in workers/leads/src/routes/admin.ts.
 */
export const QA_USER_IDS: ReadonlySet<string> = new Set([
  'user_3Jdgk4auHzgtRUDxEGAEenj8CMx', // marvin.bautista23@gmail.com (Marvin, QA)
])

export function canViewAdminConsole(userId: string | null | undefined): boolean {
  return isStaffUser(userId) || Boolean(userId && QA_USER_IDS.has(userId))
}

/**
 * Narrower gate than `isStaffUser` — restricts to Taha only. Used for
 * internal-only debug affordances (Preview AI Messages, Test Mode) that
 * even Eli/TJ shouldn't see in the customer-facing campaign view during
 * the launch window.
 */
export const TAHA_USER_ID = 'user_3C4CzlgLjarwyXJkhGHHXMGA2SE'

export function isTahaOnly(userId: string | null | undefined): boolean {
  return userId === TAHA_USER_ID
}
